import config from "../utils/getConfig";

export const API_ROUTES = {
  SEND_OTP: `${config.API_HOST}/api/auth/otp/send`,
  VERIFY_OTP: `${config.API_HOST}/api/auth/otp/verify`,
  LOGOUT: `${config.API_HOST}/api/auth/logout`,
  PROFILE: `${config.API_HOST}/api/admin/profile`,
  BOOKING_STATS: `${config.API_HOST}/api/admin/bookings/stats`,
  BOOKINGS: `${config.API_HOST}/api/admin/v2/bookings`,
  ROOMLIST: `${config.API_HOST}/api/admin/v2/rooms`,
  BLOCK_PROPERTY: `${config.API_HOST}/api/admin/v2/block/all`,
  PRICE_UPDATE: `${config.API_HOST}/api/admin/price`,
  UPDATE_DISCOUNT: `${config.API_HOST}/api/admin/discounts`,
  UPDATE_BANK: `${config.API_HOST}/api/admin/bank-details`,
  BANK_DETAIL: `${config.API_HOST}/api/admin/bank-details`,
  ROOM_WITHIN_RANGE: `${config.API_HOST}/api/admin/v2/rooms/range`,
  BULK_PRICE: `${config.API_HOST}/api/admin/price/bulk`,
  DAY_PRICE_IN_RANGE: `${config.API_HOST}/api/admin/day-price-in-range`,
  BULK_DISCOUNT: `${config.API_HOST}/api/admin/discounts/range`,
  BLOCK_ROOM: `${config.API_HOST}/api/admin/v2/block`,
  BULK_ROOM_BLOCK: `${config.API_HOST}/api/admin/v2/block/bulk`,
  BULK_PROPERTY_BLOCK: `${config.API_HOST}/api/admin/v2/block/all/bulk`,
  PRICE_UPDATE_BY_DAYS: `${config.API_HOST}/api/admin/price/bulk/days`,
  HOMESTAY_ENQUIRY: `${config.API_HOST}/api/homestay-enquiry`,
  UPDATE_ENQUIRY_STATUS: `${config.API_HOST}/api/update-enquiry-status`,
  PROPERY_SOLD_OUT_STATUS : `${config.API_HOST}/api/admin/v2/property-sold-out-status`,
  DAY_OUTING_LIST : `${config.API_HOST}/api/admin/v2/day-outing`,
  DAY_OUTING_PRICE_UPDATE: `${config.API_HOST}/api/admin/update-day-outing-price`,
  BLOCK_DAY_OUTING_PACKCAGE: `${config.API_HOST}/api/admin/block-day-outing-package`
  };
